import * as types from './mutation-types'
import * as globalTypes from '../../mutation-types'
import statelawAPI from '../../../api/statelaws.js'

export const getStateLawData = async ({commit, dispatch}, selectedState) => {
  try {
    var result = await statelawAPI.getAll(selectedState.stateID);
    commit(types.SET_SELECTED_STATE_LAW, result);
  }
  catch (e) {
    let msg = "There was an error getting all State Laws for "+ selectedState.displayName +".";
    dispatch('showError', msg, { root: true })
    throw msg;
  }
  // commit(globalTypes.LOADING_START)
  // statelawAPI.getAll(selectedState.stateID)
  // .then((response) => {
  //   if (response.data.status === 'Success') {
  //     response.data.data.state = selectedState
  //     commit(types.SET_SELECTED_STATE_LAW, response.data.data)
  //   } else {
  //     // show Error
  //     var error = {
  //       title: 'Error',
  //       message: 'ERROR',
  //       type: 'error'
  //     }

  //     commit(globalTypes.NOTIFY_ERRORS, error)
  //   }

  //   commit(globalTypes.LOADED_SUCCESS)
  // })
}

export const addAllowedItems = ({ commit }, items) => {
  commit(types.ADD_ALLOWED_ITEMS, items)
}

export const removeAllowedItems = ({ commit }, items) => {
  commit(types.REMOVE_ALLOWED_ITEMS, items)
}

export const addProofAllowedItems = ({ commit }, items) => {
  commit(types.ADD_PROOF_ALLOWED_ITEMS, items)
}

export const removeProofAllowedItems = ({ commit }, items) => {
  commit(types.REMOVE_PROOF_ALLOWED_ITEMS, items)
}

export const setSelectedStateLaw = ({ commit }, statelaw) => {
  commit(globalTypes.SET_SELECTED_NOTIFICATION, statelaw)
}

export const saveStateLaws = ({ commit }, data) => {
  commit(globalTypes.LOADING_START)
  statelawAPI.save(data)
    .then((response) => {
      if (response.data.status === 'Success') {
        let msg = {
          title: 'Saved.',
          message: 'State Laws saved successfully.',
          type: 'success'
        }
        data.is_new = false;
        commit(types.SET_SELECTED_STATE_LAW, data)
        commit(globalTypes.NOTIFY_ERRORS, msg)
      } else {
          // show Error
          var error = {
            title: 'Error',
            message: 'ERROR',
            type: 'error'
          }
        commit(globalTypes.LOADED_SUCCESS)
        commit(globalTypes.NOTIFY_ERRORS, error)
    }

      commit(globalTypes.LOADED_SUCCESS)
    })
  // commit(types.SAVE_STATE_LAW)
}



// WEBPACK FOOTER //
// ./src/store/modules/statelaws/actions.js